<template>
  <div class="container no-px2rem">
    <div class="header">
      <img
        src="//img0.didiglobal.com/static/gstar/img/wQMAM5vWRJ1583986865366.png"
        alt=""
      />
    </div>
    <div class="content">
      <div class="title">
        「DiDi Food」サービス開始から1周年記念！
        「半額祭」「2倍祭」「500円均一祭」
        めっちゃお得なキャンペーンを3つ同時開催!! ―
        新規登録者には最大4,500円分クーポンも付与 ―
      </div>
      <div class="date"><em>2021-07-07</em></div>
      <div class="banner">
        <img
          src="//img0.didiglobal.com/static/soda_public/do1_zSh3Aym42bL9JXMfpFDM.png"
          alt=""
        />
      </div>
      <div class="p tab independent">
        DiDiフードジャパン株式会社が運営するフードデリバリーサービス「DiDi
        Food」は、2021年6月23日（水）で日本でのサービス開始から1周年を迎えました。
      </div>
      
      <div class="p tab independent">
        <p>1周年を記念して、7月31日（土）までに、対象メニューが最大半額でお楽しみいただける「半額祭」、特別メニューの2つ目の注文が無料になる「2倍祭」、豪華メニューがワンコイン価格でお楽しみいただける「500円均一祭」を同時開催いたします。</p>
        <p>また、3つの1周年記念祭と同期間、新規登録の方に最大4,500円分のクーポンも付与いたします。</p>
        <p>※1周年記念の「半額祭」「2倍祭」「500円均一祭」「新規登録の方に最大4,500円分のクーポン付与」は、大阪エリア、兵庫エリア、京都エリアのみで実施いたします</p>
        <p>1年間のご愛好に感謝申し上げるとともに、これからも「DiDi
        Food」はさまざまなキャンペーンを実施し、バラエティ豊かな「食の移動体験」によってお客様に「おいしい」をお届けいたします。</p>
      </div>
      <!-- <div class="p tab independent">
        
      </div> -->
      <!-- <div class="p">
        
      </div>
      <div class="p tab independent">
        1
      </div> -->
      <!-- <br /> -->
      <div class="strong">「半額祭」</div>
      <div class="p independent">
        <div class="p">
          内容： 期間中、対象メニューが半額でご注文いただけます。
        </div>
        <div class="p">期間： ～7月31日（土）</div>
        <div class="p">※対象メニューなど詳細はアプリをご確認ください。</div>
      </div>
      <!-- <br /> -->
      <div class="strong">「2倍祭」</div>
      <div class="p independent">
        <div class="p">
          内容：
          期間中、対象メニューをご注文いただくと、1商品を無料で追加ご注文いただけます。
        </div>
        <div class="p">期間： ～7月31日（土）</div>
        <div class="p">※対象メニューなど詳細はアプリをご確認ください。</div>
      </div>
      <!-- <br /> -->
      <div class="strong">「500円均一祭」</div>
      <div class="p independent">
        <div class="p">
          内容：
          期間中、対象のメニューが特別割引価格の500円でご注文いただけます。
        </div>
        <div class="p">期間： ～7月31日（土）</div>
        <div class="p">※対象メニューはアプリをご確認ください。</div>
        <div class="p">※別途、配達料金がかかります。</div>
      </div>
      <!-- <br /> -->
      <div class="strong">新規登録者4,500円分クーポン</div>
      <div class="p independent">
        <div class="p">
          内容： 期間中、新規で「DiDi Food」にご登録いただいた方に、「DiDi
          Food」でご利 用いただけるクーポンを最大4,500円分付与いたします。
        </div>
        <div class="p">
          内訳： 初回注文無料 *1300円分まで、配達料金対象外 配達料金10回
          無料※割引上限320円/回 *2回目注文以降適用
        </div>
        <div class="p">付与対象登録期間： 終了時期未定</div>
        <div class="p">※詳細利用規定はアプリをご確認ください。</div>
      </div>
      <!-- <br /> -->
      <div class="strong">「DiDi Food」概要</div>
      <div class="p tab independent">
        「DiDi
        Food」は、数タップで地元の名物や大手飲食チェーン店の料理をご自宅やオフィス、また悪天候や行列に並びたくないときなど、その日の気分に合わせて様々なシーンでご利用頂けます。「DiDi
        Food」は地域に根差した取り組みや、愛されるメニューを取り揃え、地元のお客様に選ばれるフードデリバリーとなることを目指しております。
      </div>
      <!-- <br /> -->
      <div class="p independent">
        <div class="p padding-2">会社名：DiDiフードジャパン株式会社</div>
        <div class="p padding-2">本社所在地：東京都中央区晴海 3-10-1</div>
        <div class="p padding-2">大阪支社所在地：大阪府大阪市中央区難波5-1-60</div>
        <div class="p padding-2">
          公式WEBサイト：<a href="https://www.didi-food.com/ja-JP"
            >https://www.didi-food.com/ja-JP</a
          >
        </div>
        <div class="p">
          注文受付時間：8:00～25:00※ご提供可能時間は店舗営業時間に準じます。
        </div>
      </div>
      <!-- <br /> -->
      <div class="p p1">＜サービス提供エリア＞</div>
      <div class="p padding-2">大阪エリア</div>
      <div class="p independent">
        大阪市（南港エリアを除く）、堺市*、豊中市、池田市*、吹田市、高槻市*、守口市、枚方市*、茨木市*、八尾市*、寝屋川市、松原市*、大東市*、箕面市*、門真市、摂津市、東大阪市*、四條畷市*、交野市*
      </div>
      <!-- <br /> -->
      <div class="p padding-2">福岡エリア</div>
      <div class="p independent">
        北九州市*、福岡市、久留米市、直方市*、飯塚市、中間市*、筑紫野市、春日市、大野城市、太宰府市*、古賀市、福津市*、糸島市*、那珂川市、糟屋郡*
      </div>
      <!-- <br /> -->
      <div class="p padding-2">兵庫エリア</div>
      <div class="p independent">
        神戸市*、姫路市*、尼崎市、明石市*、西宮市*、芦屋市、伊丹市、加古川市*、宝塚市*、高砂市*、川西市*、三田市*、加古郡播磨町*
      </div>
      <div class="p padding-2">広島エリア</div>
      <div class="p independent">
        広島市（中区、東区*、南区、西区、安佐南区*、安佐北区*、佐伯区*）、福山市*、東広島市*、廿日市市*、安芸郡府中町*
      </div>

      
      <div class="p padding-2">京都エリア</div>
      <div class="p independent">
        京都市*、宇治市、亀岡市*、城陽市、向日市、長岡京市*、八幡市、京田辺市、大山崎町、久世郡久御山町
      </div>

      
      <div class="p padding-2">愛知エリア</div>
      <div class="p independent">
        名古屋市（千種区、東区、北区、西区、中村区、中区、昭和区、瑞穂区、熱田区、中川区*、港区*、南区、守山区*、緑区*、名東区、天白区*）
      </div>

      
      <div class="p padding-2">沖縄エリア</div>
      <div class="p independent">那覇市、宜野湾市*、浦添市、豊見城市*、南風原町*</div>

      
      <div class="p padding-2">*一部を除く</div>
      <div class="p">
        ※上記エリア内であっても、山間部や離島などではご利用いただけない場合がございます。また、店舗の営業状況などにより、ご注文いただけない場合もございますので、ご了承ください。
      </div>
      <div class="p padding-2">※詳細なエリアはアプリにてご確認ください。</div>
      <div class="p">
        ※沖縄エリアは8月上旬サービス提供開始予定、予告なくサービス提供エリアを変更する可能性がございます。
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Japan0708'
}
</script>

<style scoped lang="scss">
@media screen and (min-width: 750px) {
  .container.no-px2rem .content div.p {
    box-sizing: border-box;
    line-height: 1.42;
    height: 100%;
    outline: none;
    tab-size: 4;
    -moz-tab-size: 4;
    text-align: left;
    padding: 6px 0;
    word-wrap: break-word;
    font-size: 22px;
    color: rgb(0, 0, 0);
    &.tab {
      text-indent: 0.5rem;
    }

    &.independent {
      padding-bottom: 40px;
      p {
        padding-bottom: 10px;
      }
    }
  }
  .container.no-px2rem .content div.strong {
    background-color: transparent;
    color: rgb(0, 0, 0);
    font-size: 24px;
    font-weight: 500;
  }

}
.container.no-px2rem {
  max-width: 750px;
  margin: 0 auto;
  .header img {
  vertical-align: top;
  overflow: hidden;
  width: 100%;
  object-fit: contain;
  }

  .content {
    padding: 10px 15px 30px;

    .title {
      margin-bottom: 12px;
      line-height: 1.4;
      font-weight: 400;
      font-size: 24px;
    }

    .date {
      display: inline-block;
      vertical-align: middle;
      margin-right: 8px;
      margin-bottom: 10px;
      font-size: 16px;
      color: #8c8c8c;
      em {
        font-style: normal;
      }
    }
    .banner {
      margin-bottom: 15px;
    }
    .banner img {
      width: 100%;
    }
  }
  .p {
      box-sizing: border-box;
      line-height: 1.42;
      height: 100%;
      outline: none;
      tab-size: 4;
      -moz-tab-size: 4;
      text-align: left;
      word-wrap: break-word;
      font-size: 12px;
      padding: 2px 0;
      color: rgb(0, 0, 0);
      &.p1 {
        font-size: 14px;
        font-weight: 500;
      }
      &.padding-2 {
        padding: 2px 0;
      }
      &.tab {
        text-indent: 1rem;
      }

      &.independent {
        padding-bottom: 20px;
        p {
          padding-bottom: 5px;
        }
      }
    }

 
  .strong {
    background-color: transparent;
    color: rgb(0, 0, 0);
    font-size: 16px;
    font-weight: 500;
  }

  .img-inline {
    img {
      width: 177px;
    }
  }
}
 
</style>
